import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined'
import { Badge } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { PAGES_ROUTES } from '../../Constants'
import { getNotifOnScreenPermissions } from '../../Helpers/Permission'
import { useAppDispatch, useAppSelector } from '../../Store/Hooks'
import { getNonDeliveredNotifications, setUnreadCount } from '../../Store/Slice/notifications.slice'
import MUITooltip from '../Shared/MUI-Tooltip'

const NotificationSSE = ({ isHeader = true }: { isHeader?: boolean }) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { cmsConfig } = useAppSelector((state) => state.appConfig)
  const { unreadCount } = useAppSelector((state) => state.notifications)
  const { NOTIF_POLLING_INTERVAL = 10000, NOTIF_POLLING_NON_DEL_INTERVAL = 2000 } = cmsConfig

  const permissions = getNotifOnScreenPermissions()

  useEffect(() => {
    let isRequestInProgress = false
    const lastFetchTime = () =>
      new Date(Date.now() - (NOTIF_POLLING_INTERVAL + NOTIF_POLLING_NON_DEL_INTERVAL))

    const fetchNotifications = async () => {
      if (isRequestInProgress || document.hidden || !isHeader) return // Stop polling if the tab is not active
      isRequestInProgress = true
      try {
        const resData = await dispatch(
          getNonDeliveredNotifications({
            apiPayload: {
              limit: 10,
              minDate: new Date(lastFetchTime()).toISOString(),
            },
            showLoader: false,
          }) as any,
        )
        if (resData?.payload?.responseCode === 200) {
          dispatch(setUnreadCount(resData.payload.data.unreadNotifications))
          let onScreenNotifications = resData.payload.data.notifications || []
          onScreenNotifications = onScreenNotifications.filter(
            (notification: any) => permissions[notification.eventKey],
          )
          onScreenNotifications.forEach((notification: any, index: number) => {
            setTimeout(() => {
              onMessageRecieved(notification.notificationTitle, notification.notificationMessage)
            }, 1000 * index)
          })
        }
      } finally {
        isRequestInProgress = false
      }
    }

    const intervalId = setInterval(fetchNotifications, NOTIF_POLLING_INTERVAL)

    fetchNotifications()
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        fetchNotifications() // Fetch immediately when the tab becomes active
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      clearInterval(intervalId)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  const onMessageRecieved = (event: string, message: string) => {
    enqueueSnackbar(event, {
      variant: 'snackbarNotification',
      data: {
        message,
      },
      onClickAction: () => {
        navigate(PAGES_ROUTES.AllNotificationsPage)
      },
    })
  }

  return (
    <Badge
      color='error'
      variant={unreadCount ? 'dot' : 'standard'}
      overlap='circular'
      invisible={!unreadCount}
    >
      <MUITooltip title={'View Notifications'} placement={'left'}>
        <NotificationsNoneOutlinedIcon />
      </MUITooltip>
    </Badge>
  )
}

export default NotificationSSE
